import { apiClient } from 'utils/CLIENT';

export async function fetchTranslations(shortCode: string): Promise<Record<string, string>> {
  const response = await apiClient.get(`/lt-booking/translations/${shortCode}`);
  return response.data || {};
}
